import getLocationInfo from './event-list/getLocationInfo.js'
import { login } from './event-list/login.js'
import { getPageConfig } from './event-list/getPageConfig.js'
import { getShareConfig } from './event-list/share.js'

export const eventMap = {
  getLocationInfo,
  login,
  getPageConfig,
  getShareConfig
}
